<template>
	<div class="bg">
		<div class="top_search_part">
			<div class="search_box">
				<div class="goBackBox" @click="goBack" style="margin-right: 20px;">
					<img class="goBackIcon" src="@/assets/backIcon.svg" />
					<span class="goBackTitle">{{ $t('message.backText') }}</span>
				</div>
				<div class="search_item">
					<img class="goBackIcon" src="@/assets/dateIcon.svg" />
					<span class="goBackTitle">{{ date }} {{ city }}</span>
				</div>
			</div>
			<div class="search_box">
				<div class="add_btn" @click="addNewOrder" style="margin-right: 20px;">
					<img class="add_icon" src="@/assets/addIcon.svg" />
					{{ $t('message.newContainerTitle') }}
				</div>
				<div class="add_btn" v-if="(city === '藤井寺'||city === '市川') && isAdmin" style="margin-right: 28px;" @click="downloadTemplate"><img class="add_icon" src="@/assets/downloadIocn.svg" />{{$t('message.downLoadExcel')}}</div>
				<div class="search_btn" v-if="(city === '藤井寺'||city === '市川') && isAdmin" @click="imp_4kws1()">{{ $t('message.ImpSumOrder') }}</div>
				<div class="search_btn" @click="kanto_kansai_receipt('tally')">{{ $t('message.FBASKUtally') }}</div>
				<div class="search_btn" @click="kanto_kansai_receipt('kanto')" v-if="isAdmin">{{ $t('message.kantoReceipt') }}</div>
				<div class="search_btn" @click="kanto_kansai_receipt('kansai')" v-if="isAdmin">{{ $t('message.kansaiReceipt') }}</div>
				<div class="search_btn" @click="kanto_kansai_receipt('return')" v-if="isAdmin">{{ $t('message.containerReturnReceipt') }}</div>
				<div class="search_btn" @click="exportContainerOrders">{{ $t('message.exportText') }}</div>
			</div>
		</div>
		<div class="content">
			<div class="tableBox">
				<el-table
					id="orderList"
					:data="orderList"
					style="width: 100%"
					height="100%"
					stripe
					size="small"
					header-cell-class-name="tableHeader"
					cell-class-name="tableBodyer"
					@sort-change="sortChange"
					border
				>
					<!-- <el-table-column type="expand" fixed="left">

            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand" label-width="150px">
                <el-form-item :label="$t('message.deliveryDate')">
                  <span>{{props.row.deliveryDate}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerGoodsModel')">
                  <span>{{props.row.JZXSIZE}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerOrderNumber')">
                  <span>{{props.row.JZXNUM}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.inspection')">
                  <span>{{props.row.GPJC}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerOrderNum')">
                  <span>{{props.row.SHULIANG}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerOrderWeight')">
                  <span>{{props.row.ZHONGLIANG}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerOrderVolume')">
                  <span>{{props.row.TIJI}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.litijin')">
                  <span>{{props.row.LITIJIN}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.containerOrderRemark')">
                  <span>{{props.row.REMARK}}</span>
                </el-form-item>
                <el-form-item :label="$t('message.orderTableTitle11')">
                  <span>{{props.row.addTime}}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column> -->

					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60" fixed="left"></el-table-column>
					<!-- <el-table-column :label="$t('message.containerJOBNO')" prop="JOBNO" width="120" fixed="left"></el-table-column> -->
					<el-table-column :label="$t('message.CarNoTitle')" prop="DDCARNO" width="100" fixed="left">
						<template slot-scope="scope">
							<span v-if="scope.row.DDCARNO != null && scope.row.DDCARNO != ''">{{ scope.row.DDCARNO }} {{ scope.row.DRIVERNAME }}</span>
							<span v-else-if="scope.row.CARADNDRIVER != null && scope.row.CARADNDRIVER != '' && isAdmin" @click="updateSiJi(scope.row.ID)">{{ scope.row.CARADNDRIVER }}</span>
							<span v-else-if="scope.row.CARADNDRIVER != null && scope.row.CARADNDRIVER != ''">{{ scope.row.CARADNDRIVER }}</span>
							<span
								v-if="isAdmin && (scope.row.CARADNDRIVER === null || scope.row.CARADNDRIVER === '') && (scope.row.DDCARNO === null || scope.row.DDCARNO === '')"
								@click="updateSiJi(scope.row.ID)"
							>
								{{ $t('message.setStatus') }}
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerCreater')" prop="GUDING1" width="120" fixed="left">
						<template slot-scope="scope">
							<span v-if="isAdmin" @click="showHeaderDialog(scope.row.ID)">{{ scope.row.GUDING1 }}</span>
							<span v-else>{{ scope.row.GUDING1 }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.signatureAddTimeTitle')" prop="ADDTIME" width="65" fixed="left">
						<template slot-scope="scope" >
							<span style="white-space:pre-line;">{{ scope.row.ADDTIME | formDate }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerOrderCustomerID')" prop="customerId" width="160" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.customerDedicatedNum')" prop="KRZYBH" width="120" fixed="left"></el-table-column>
					<!-- <el-table-column :label="$t('message.containerOrderCustomer')" prop="KEREN" width="160" fixed="left"></el-table-column> -->
					<el-table-column :label="$t('message.placeOfDelivery')" prop="placeOfDelivery" width="160" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.deliveryDate')" prop="DDDATE" width="130"></el-table-column>
					<el-table-column :label="$t('message.containerStripping')" prop="DATIME" width="140"></el-table-column>
					<el-table-column :label="$t('message.containerGoodsModel')" width="140" sortable="custom" prop="JZXSIZE">
						<template slot-scope="scope">
							<span
								:class="{
									color1: scope.row.JZXSIZE === '40GP/HQ',
									color2: scope.row.JZXSIZE === '20GP/HQ',
									color3: scope.row.JZXSIZE === 'CFS',
									color4: scope.row.JZXSIZE === 'KIX',
									color5: scope.row.JZXSIZE === 'NRT',
									color6: scope.row.JZXSIZE === 'HND',
									color7: scope.row.JZXSIZE === '4KWS1',
									color8: scope.row.JZXSIZE === '2SWH7',
									color9: scope.row.JZXSIZE === '1FWX6'
								}"
							>
								{{ scope.row.JZXSIZE }}
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerOrderNumber')" prop="JZXNUM" min-width="150"></el-table-column>
					<el-table-column :label="$t('message.trailerArrangement')" min-width="150">
						<template slot-scope="scope">
							<span style="white-space:pre-line;">{{ scope.row.TCAP }} {{ scope.row.TCAPDZ }}</span>
						</template>
					</el-table-column>
					<!-- 					<template slot-scope="scope" :label="$t('message.containerTrailerArrangement')">

						<span>
							
						</span>
					</template> -->

					<el-table-column :label="$t('message.goodsStatus')" width="120">
						<template slot-scope="scope">
							<el-button class="operation_a_blue" type="text" size="small" :disabled="!isAdmin" @click="updateGoodsStatus(scope.row.ID)">
							<span v-if="(scope.row.goodsStatus == '设置' || scope.row.goodsStatus == '設置')">{{ scope.row.goodsStatus }}</span>
							<span v-if="(scope.row.goodsStatus == '未' || scope.row.goodsStatus == '未抵达')" style="color:#ff0000;font-weight:bold;">{{ scope.row.goodsStatus }}</span>
							<span v-if="(scope.row.goodsStatus == '到着' || scope.row.goodsStatus == '已抵达')" style="color:#00aa00;font-weight:bold;">{{ scope.row.goodsStatus }}</span>
							<span v-if="(scope.row.goodsStatus == '完了' || scope.row.goodsStatus == '已拆柜')" style="color:#0000ff;font-weight:bold;">{{ scope.row.goodsStatus }}</span>
							<span v-if="(scope.row.goodsStatus == '出庫済' || scope.row.goodsStatus == '空柜已出库')" style="color:#FFA500;font-weight:bold;">{{ scope.row.goodsStatus }}</span>
							</el-button>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.inspection')" prop="GPJC" width="110"></el-table-column>
					<el-table-column :label="$t('message.containerOrderNum')" prop="SHULIANG" width="150"></el-table-column>
					<el-table-column :label="$t('message.containerOrderWeight')" prop="ZHONGLIANG" width="150"></el-table-column>
					<el-table-column :label="$t('message.containerOrderVolume')" prop="TIJI" width="150"></el-table-column>
					<el-table-column :label="$t('message.litijin')" prop="LITIJIN" width="120"></el-table-column>
					<el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK" width="200" resizable></el-table-column>
					
					<el-table-column :label="$t('message.XuKeText')" width="70">
						<template slot-scope="scope">
							<!-- class="operation_a_blue" -->
							<el-button :class="[ scope.row.GUDING5 === '未許可'?'RedText':'GreenText' ]" type="text" size="small" :disabled="!isAdmin"  @click="updateXuKeStatus(scope.row.ID,scope.row.JZXSIZE)">{{ scope.row.GUDING5 }}</el-button>
						</template>
					</el-table-column>
					
					<el-table-column :label="$t('message.containerOrderAttacherFile')" width="100">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkFiles(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.FILECOT + ')' }}</a>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.FBASKUtally')" width="150">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkFBASKUtally(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.BQCOT + ')' }}</a>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.kantoReceipt')" width="100">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkKantoReceipt(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.GDQSDCOT + ')' }}</a>

							<el-button
								class="operation_btn PriBtn"
								type="text"
								size="small"
								@click.native.prevent="SetOrderPrint(scope.row.ID, 'GDQSDUSER')"
								v-if="isAdmin && (scope.row.GDQSDUSER == null || scope.row.GDQSDUSER == '')"
							></el-button>
							<span v-if="isAdmin && scope.row.GDQSDUSER !== null && scope.row.GDQSDUSER !== ''">
								<br />
								{{ '(' + scope.row.GDQSDNAME + ')' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.kansaiReceipt')" width="100">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkKansaiReceipt(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.QSDCOT + ')' }}</a>
							<el-button
								class="operation_btn PriBtn"
								type="text"
								size="small"
								@click.native.prevent="SetOrderPrint(scope.row.ID, 'GXQSDUSER')"
								v-if="isAdmin && (scope.row.GXQSDUSER == null || scope.row.GXQSDUSER == '')"
							></el-button>
							<span v-if="isAdmin && scope.row.GXQSDUSER !== null && scope.row.GXQSDUSER !== ''">
								<br />
								{{ '(' + scope.row.GXQSDNAME + ')' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerReturnReceipt')" width="100">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkReturnReceipt(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.HCDCOT + ')' }}</a>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerOrdersDetails')" width="100">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkContainerOrders(scope.row)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.AMZNUMS + ')' }}</a>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.billTitle')" width="100" v-if="specialIdentity === 'FC' || specialIdentity === 'administrator'">
						<template slot-scope="scope">
							<a class="operation_a_blue" @click="checkBills(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.ZDCOT + ')' }}</a>
						</template>
					</el-table-column>
					<!-- <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" width="170"></el-table-column> -->
					<el-table-column :label="$t('message.customTableTitle5')" width="200">
						<template slot-scope="scope">
							<div class="operate_btn_box">
								<el-button
									class="operation_btn sendEmailBtn"
									type="text"
									size="small"
									@click.native.prevent="sendEmail(scope.row.ADDUSER, scope.row.ID)"
									v-if="isAdmin"
								></el-button>
								<el-button
									class="operation_btn updateBtn"
									type="text"
									size="small"
									@click.native.prevent="updateOrder(scope.row)"
									v-if="isAdmin || scope.row.ISCANEDIT !== 'N'"
								></el-button>
								<el-button
									class="operation_btn delBtn"
									type="text"
									size="small"
									@click.native.prevent="delOrder(scope.row.ID)"
									v-if="isAdmin || scope.row.ISCANEDIT !== 'N'"
								></el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>
		<!-- 创建订单dialog -->
		<el-dialog :title="dialogTitle" :visible.sync="showDialog" destroy-on-close :close-on-click-modal="false" center top="5vh" width="65%">
			<div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderCity') }}:</span>
						<el-input v-model="city" disabled></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerJOBNO') }}:</span>
						<el-input v-model="JOBNO" :disabled="!JOBNOCanInput" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerGoodsModel') }}:</span>
						<el-radio-group v-model="containerModel" @change="changeLeixing($event)">
							<!-- <el-radio label="40GP/HQ">40GP/HQ</el-radio>
              <el-radio label="20GP/HQ">20GP/HQ</el-radio> -->
							<el-radio label="集装箱">{{ $t('message.containerText') }}</el-radio>
							<el-radio label="CFS">CFS</el-radio>
							<el-radio label="NRT" v-if="city === '東京'">NRT</el-radio>
							<el-radio label="HND" v-if="city === '東京'">HND</el-radio>
							<el-radio label="1FWX6" v-if="city === '大田'">1FWX6</el-radio>
							<el-radio label="KIX" v-if="city === '大阪'">KIX</el-radio>
							<el-radio label="4KWS1" v-if="city === '藤井寺'">4KWS1</el-radio>
							<el-radio label="2SWH7" v-if="city === '市川'">2SWH7</el-radio>
							<!-- <el-radio label="2SWH7" v-if="city === '東京'">2SWH7({{ $t('message.xukejihuowu') }})</el-radio>
							<el-radio label="4KWS1" v-if="city === '大阪'">4KWS1({{ $t('message.xukejihuowu') }})</el-radio> -->
						</el-radio-group>
					</div>
					<div class="dialog_item" v-if="containerModel === '集装箱'">
						<span class="dialog_item_title">{{ $t('message.containerOrderNumber') }}:</span>
						<el-radio-group v-model="containerCodeType" style="flex-shrink: 0;margin-right: 10px;">
							<el-radio label="40GP/HQ">40GP/HQ</el-radio>
							<el-radio label="20GP/HQ">20GP/HQ</el-radio>
						</el-radio-group>
						<el-input v-model="containerCoding" :placeholder="$t('message.placeholder')" style="width:120px;"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item" v-if="containerModel !== '集装箱'">
						<span class="dialog_item_title">{{ $t('message.placeOfDelivery') }}:</span>
						<el-select v-model="placeofCity" style="margin-right: 10px;">
							<!-- 							<el-option :label="$t('message.selectTokyo')" :value="$t('message.selectTokyo')"></el-option>

							<el-option :label="$t('message.selectYokohama')" :value="$t('message.selectYokohama')"></el-option>
							<el-option :label="$t('message.selectOsaka')" :value="$t('message.selectOsaka')"></el-option>
							<el-option :label="$t('message.selectNagoya')" :value="$t('message.selectNagoya')"></el-option>
							<el-option :label="$t('message.selectKobe')" :value="$t('message.selectKobe')"></el-option>
							<el-option :label="$t('message.selectOther')" :value="$t('message.selectOther')"></el-option> -->

							<el-option label="東京(东京)" value="東京"></el-option>
							<el-option label="横浜(横滨)" value="横浜"></el-option>
							<el-option label="大阪(大阪)" value="大阪"></el-option>
							<el-option label="名古屋(名古屋)" value="名古屋"></el-option>
							<el-option label="神戸(神户)" value="神戸"></el-option>
							<el-option label="その他(其他)" value="その他"></el-option>
						</el-select>
						<el-input v-model="placeOfDelivery" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item" v-show="containerModel === '集装箱'||containerModel === '4KWS1'||containerModel === '2SWH7'">
						<span class="dialog_item_title">{{ $t('message.containerStripping') }}:</span>
						<el-date-picker v-model="delayDate" type="date" :editable="false" :clearable="false" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
						<div v-show="containerModel === '集装箱'">
						<el-time-picker v-model="arrivalDate" :editable="false" :clearable="false" value-format="HH:mm" format="HH:mm" style="margin-right: 10px;"></el-time-picker>

						<span class="dialog_item_title">{{ $t('message.trailerArrangement') }}:</span>
						<el-select v-model="containerTrailerCity" style="margin-right: 10px;flex-shrink: 0;width: 25%; " @change="saveSelectTH">
							<el-option style="white-space:pre-line;" :label="$t('message.containerTransportWays1')" :value="$t('message.containerTransportWays1')"></el-option>
							<el-option style="white-space:pre-line;" :label="$t('message.containerTransportWays11')" :value="$t('message.containerTransportWays11')"></el-option>
							<el-option style="white-space:pre-line;" :label="$t('message.containerTransportWays2')" :value="$t('message.containerTransportWays2')"></el-option>
							<el-option style="white-space:pre-line;" :label="$t('message.containerTransportWays21')" :value="$t('message.containerTransportWays21')"></el-option>
							<el-option style="white-space:pre-line;" :label="$t('message.containerTransportWays3')" :value="$t('message.containerTransportWays3')"></el-option>
						</el-select>
						<div style="width: 18%; flex-shrink: 0; float: right;" v-show="containerTrailerCity === $t('message.containerTransportWays3')">
							<el-input v-model="trailerLocation" :placeholder="$t('message.placeholder')"></el-input>
						</div>
							
						</div>
					</div>

					<div class="dialog_item" v-if="containerModel !== '集装箱'">
						<span class="dialog_item_title">{{ $t('message.deliveryDate') }}:</span>
						<el-date-picker
							v-model="deliveryDate"
							type="date"
							:editable="false"
							:clearable="false"
							value-format="yyyy-MM-dd"
							format="yyyy-MM-dd"
							style="margin-right: 10px;flex-shrink: 0;"
						></el-date-picker>
						<el-select v-model="hasSpecifyTime" style="margin-right: 10px;width: 60px;">
							<el-option :value="false" :label="$t('message.noSpecifyTime')"></el-option>
							<el-option :value="true" :label="$t('message.hasSpecifyTime')"></el-option>
						</el-select>
						<el-input v-model="specifyTime" :placeholder="$t('message.placeholder') + $t('message.specifyTime')" :disabled="!hasSpecifyTime" style="width: 90px;"></el-input>
					</div>
				</div>
				<div class="dialog_row"></div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.inspection') }}</span>
						<el-select v-model="inspection" multiple style="flex-grow: 1;">
							<el-option label="X線検査" value="X線検査"></el-option>
							<el-option label="開被検査" value="開被検査"></el-option>
							<el-option label="改品検査" value="改品検査"></el-option>
						</el-select>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderCustomerID') }}:</span>
						<el-select v-model="customerSel" :filterable="isAdmin" :placeholder="$t('message.exportDatePlaceholder')" style="flex-grow: 1;">
							<el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.label + ',' + item.value"></el-option>
						</el-select>
					</div>
				</div>
				<!-- <div class="dialog_row">

          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.containerOrderCustomer')}}:</span>
            <el-input v-model="containerCustomer" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div> -->

				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.XuKeText') }}</span>
						<el-select v-model="containerxuke" default-first-option>
							<el-option label="未許可" value="未許可"></el-option>
							<el-option label="許可済" value="許可済"></el-option>
						</el-select>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.customerDedicatedNum') }}</span>
						<el-input v-model="dedicatedNum" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderNum') }}:</span>
						<el-input v-model="containerNumber" :placeholder="$t('message.placeholder')" type="number"></el-input>
						<div class="dialog_item_input_text" style="width:200px;flex-shrink: 0;text-align: left;">
							<el-select v-model="containerNumberUnit" filterable allow-create default-first-option clearable :placeholder="$t('message.numberUnitPlaceholder')">
								<el-option label="CTNS" value="CTNS"></el-option>
								<el-option label="PLTS" value="PLTS"></el-option>
								<el-option label="PKGS" value="PKGS"></el-option>
							</el-select>
						</div>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderWeight') }}:</span>
						<el-input v-model="containerWeight" :placeholder="$t('message.placeholder')" type="number" style="flex-grow: 1;"></el-input>
						<div class="dialog_item_input_text" style="flex-shrink: 0;text-align: left;">KGS</div>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderVolume') }}:</span>
						<el-input v-model="containerVolume" :placeholder="$t('message.placeholder')" type="number" style="flex-grow: 1;"></el-input>
						<div class="dialog_item_input_text" style="flex-shrink: 0;text-align: left;">m³</div>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">立替金</span>
						<el-input v-model="goldMoney" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderRemark') }}:</span>
						<el-input v-model="remark" :placeholder="$t('message.placeholder')" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" style="flex-grow: 1;"></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerOrderAttacherFile') }}:</span>
						<el-upload :action="uploadFile()" :on-success="handleSuccess" class="uploadBox" :on-remove="handleRemove" :file-list="attacherFile">
							<el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
						</el-upload>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="showDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="addNewConfirm">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 创建订单dialog -->
		<!-- 附加文件dialog -->
		<el-dialog :title="$t('message.containerOrderAttacherFile')" :visible.sync="showAttachment" destroy-on-close :close-on-click-modal="false" center width="40%">
			<div>
				<div class="dialog_row" v-for="(file, index) in attachmentList" :key="index">
					<div class="dialog_item" style="display: flex;justify-content: center;align-items: center;">
						<!-- <a :href="file.url" :download="file.FILEOLDNAME" target="_blank">{{file.FILEOLDNAME}}</a> -->
						<span>{{ file.FILEOLDNAME }}</span>
						<el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file, 'FJ')">{{ $t('message.download') }}</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 附加文件dialog -->
		<!-- 关东签收单dialog -->
		<el-dialog :title="$t('message.kantoReceipt')" :visible.sync="showKantoDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div>
				<div class="dialog_row">
					<div class="dialog_item" style="display: flex;justify-content: center;">
						<el-upload :action="uploadFile()" multiple :on-success="kantoSuccess" :on-remove="kantoRemove" :file-list="receiptList">
							<!--  :file-list="attacherFile" -->
							<el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
						</el-upload>
					</div>
					<div class="dialog_item" style="display: flex;flex-direction: column;align-items: center;">
						<div v-for="(file, index) in receiptList" :key="index">
							<span>{{ file.FILEOLDNAME }}</span>
							<el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file, 'OGD')">{{ $t('message.download') }}({{ file.cot }})</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 关东签收单dialog -->
		<!-- 关西签收单dialog -->
		<el-dialog :title="$t('message.kansaiReceipt')" :visible.sync="showKansaiDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div>
				<div class="dialog_row">
					<div class="dialog_item" style="display: flex;justify-content: center;">
						<el-upload :action="uploadFile()" multiple :on-success="kansaiSuccess" :on-remove="kansaiRemove" :file-list="receiptList">
							<!--  :file-list="attacherFile" -->
							<el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
						</el-upload>
					</div>
					<div class="dialog_item" style="display: flex;flex-direction: column;align-items: center;">
						<div v-for="(file, index) in receiptList" :key="index">
							<span>{{ file.FILEOLDNAME }}</span>
							<el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file, 'OGX')">{{ $t('message.download') }}({{ file.cot }})</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 关西签收单dialog -->
		<!-- 回传签收单dialog -->
		<el-dialog :title="$t('message.containerReturnReceipt')" :visible.sync="showReturnReceiptDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div>
				<div class="dialog_row">
					<div class="dialog_item" style="display: flex;justify-content: center;">
						<el-upload class="uploadBox" :action="uploadFile()" multiple :on-success="returnReceiptSuccess" :on-remove="returnReceiptRemove" :file-list="receiptList">
							<!--  :file-list="attacherFile" -->
							<el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
						</el-upload>
					</div>
					<div class="dialog_item" style="display: flex;flex-direction: column;align-items: center;">
						<div v-for="(file, index) in receiptList" :key="index">
							<span>{{ file.FILEOLDNAME }}</span>
							<el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file, 'HCD')">{{ $t('message.download') }}</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 回传签收单dialog -->
		<!-- 关东、关西、回传签收单 -->
		<el-dialog :title="receiptDialogTitle" :visible.sync="receiptDialog" destroy-on-close :close-on-click-modal="false" center>
			<div class="dialog_box">
				<div class="top_search_part">
					<div class="search_box"></div>
					<div class="search_box">
						<div class="search_btn" @click="downloadmutipleFiles">{{ $t('message.download') }}</div>
					</div>
				</div>
				<div class="content">
					<el-table
						id="receiptShowList"
						:data="receiptShowList"
						style="width: 100%"
						stripe
						size="small"
						header-cell-class-name="tableHeader"
						cell-class-name="tableBodyer"
						@selection-change="selectReceipt"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60"></el-table-column>
						<el-table-column :label="$t('message.signatureFormName')" prop="name" min-width="200"></el-table-column>
						<el-table-column :label="$t('message.downloadNumber')" prop="downcot" min-width="60"></el-table-column>
						<el-table-column :label="$t('message.customTableTitle5')" width="120">
							<template slot-scope="scope">
								<div class="operate_btn_box">
									<el-button
										class="operation_a_blue"
										type="text"
										size="small"
										@click="loadMultipleFiles(scope.row.FILENAME, receiptDialogTitle === $t('message.containerReturnReceipt') ? 'HCD' : (receiptDialogTitle === $t('message.kantoReceipt') ? 'GD' : 'GX'))"
									>
										{{ $t('message.download') }}
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-pagination
					style="position: unset;"
					@size-change="receiptSizeChange"
					@current-change="receiptCurrentChange"
					:current-page="receipt_page_no"
					:page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="receipt_page_size"
					layout="total, sizes, prev, pager, next"
					:total="receiptDialogList.length"
					class="tablePage"
				></el-pagination>
			</div>
		</el-dialog>
		<!-- 关东、关西签收单 -->
		<!-- FBA/SKU标签 -->
		<el-dialog  :title="$t('message.FBASKUtally')" :visible.sync="tallyDialog" destroy-on-close :close-on-click-modal="false" center width="85%">
			<el-dialog
      width="30%"
      title="上传进度"
      :visible.sync="innerVisible"
			@close="clearFiles"
      append-to-body>
			<div class="file">
				<div class="file_item"  v-for="(item,index) in fileArr" :key="index">
						<span class="name" >{{item.name}}</span>
						<div class="progress"  v-if="item.progressFlag">
								<el-progress :percentage="item.progressPercent"></el-progress>
						</div>
						<span v-else-if="item.successFlag">上传成功!</span>
						<span v-else>上传失败!</span>
				</div>
		</div>
			</el-dialog>
			<div class="dialog_box">
				<div class="top_search_part">
					<div class="search_box">
						<el-link
							class="dialog_item_title"
							style="height: 40px; background-color: #409eff;color: #fff;border: 0;font-weight: 500; font-size: 14px;"
							type="primary"
							:underline="false"
							:href="templateDownload"
						>
							{{ $t('message.downLoadExcel') }}
						</el-link>
						<!-- <el-button size="medium" type="primary" @click="templateDownload">{{ $t('message.downLoadExcel') }}</el-button> -->
					</div>

					<div class="search_box">
						<div class="search_item" v-if="!receiptList.length">
							<el-button size="medium" type="primary" @click="uploadDialog = true">{{ $t('message.importExcelTitle') }}</el-button>
						</div>
						<!-- <div class="search_item" v-else> -->
						<div class="search_item" v-else>
							<el-button size="medium" type="primary" @click="clickDelBiaoQian">{{ $t('message.delOrderText') }}</el-button>
							<el-button size="medium" type="primary" @click="clickDowlBiaoQian">{{ $t('message.exportText') }}{{ $t('message.uploadFileTitle') }}</el-button>
							<!--        <el-link
                class="dialog_item_title add_btn"
                style="margin-left: 10px; background-color: #409eff;color: #fff;border: 0;"
                type="primary"
                :underline="false"
                :href="clickDowlBiaoQian"
              >
                {{ $t('message.exportText') }}{{ $t('message.uploadFileTitle') }}
              </el-link> -->

							<el-link
								class="dialog_item_title"
								style="height: 40px;margin-left: 10px; background-color: #409eff;color: #fff;border: 0;font-weight: 500;
    font-size: 14px;"
								type="primary"
								:underline="false"
								target="_blank"
								:href="BianQianQrPage"
							>
								{{ $t('message.downloadCode') }}
							</el-link>
							<!-- <el-button size="medium" type="primary" @click.native.prevent="loadMultipleQRcode(scope.row)">{{ $t('message.downloadCode') }}</el-button> -->
						</div>
						<el-upload class="uploadBox" ref="my-upload"  :file-list="fileArr"  :before-upload="beforeUploadFile" :on-progress="uploadFileProcess" :action="uploadFile()" multiple :on-success="tallySuccessFbaAndSku" :show-file-list="false" :on-exceed="uploadExceed" >
							<el-button size="small" type="primary">{{ $t('message.addFileFBA') }}</el-button>
						</el-upload>
					</div>
				</div>
				<div class="content">
					<el-table
						id="tallyList"
						:data="receiptList"
						style="width: 100%"
						stripe
						@expand-change="toggleRowExpansion"
						:row-key="getRowKeys"
						:expand-row-keys="expands"
						lazy
						size="small"
						header-cell-class-name="tableHeader"
						cell-class-name="tableBodyer"
					>
						<el-table-column type="expand">
							<template slot-scope="props">
								<!-- props.row.SKUList -->
								<!-- <el-table :data="props.row.SKUList" align="center" stripe> -->
								<el-table :data="SKUList" align="center" stripe>
									<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="80" sortable></el-table-column>
									<el-table-column :label="$t('message.uploadFileTitle')" align="center" prop="FILEOLDNAME">
										<template slot-scope="scope">
											<div id="" v-show="!scope.row.FILEOLDNAME">
												<el-upload style="display: inline-block;margin: 0 5px;" :action="uploadFile()" :on-success="SKUSuccess" :show-file-list="false">
													<el-button class="operation_a_blue" @click="savesSKUID(scope.row)" size="small" type="text">{{ $t('message.signatureNotOrder') }}</el-button>
												</el-upload>
											</div>
											<div id="" v-show="scope.row.FILEOLDNAME">
												<span>{{ scope.row.FILEOLDNAME }}&nbsp;&nbsp;&nbsp;({{ scope.row.cnum }})</span>
												&nbsp;&nbsp;&nbsp;
												<el-button
													class="operation_a_blue el-icon-circle-close"
													style="color: red;"
													@click="BinBiaoQianFile('', '', 'skutally', scope.row)"
													size="small"
													type="text"
												></el-button>
											</div>
										</template>
									</el-table-column>
									<el-table-column :label="$t('message.SKUTagNo')" prop="SKULST" min-width="100"></el-table-column>
									<el-table-column :label="$t('message.SKUNumber')" prop="PCS" min-width="80"></el-table-column>
									<el-table-column :label="$t('message.tradeName')" prop="SPMC" min-width="80"></el-table-column>
									<el-table-column :label="$t('message.productRemarks')" prop="SPBK" min-width="120"></el-table-column>
									<el-table-column :label="$t('message.commodityPhotos')" prop="SPXZ" min-width="120"></el-table-column>
									<el-table-column :label="$t('message.downloadNumber')" prop="cot" min-width="80" sortable></el-table-column>
									<el-table-column :label="$t('message.customTableTitle5')" width="200">
										<template slot-scope="scope">
											<div class="operate_btn_box">
												<!-- <el-button class="operation_a_blue" type="text" size="small" @click="uploadDialog = true">{{ $t('message.savesOrderText') }}</el-button> -->
												<el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="loadMultipleFiles(scope.row.FILENAME, 'BQDT')">
													{{ $t('message.download') }}
												</el-button>
												<!--                       <el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="delSKUTallyFiles(scope.row.ID)">
                          {{ $t('message.delOrderText') }}
                        </el-button> -->
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>

						<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="80" sortable></el-table-column>
						<el-table-column :label="$t('message.FBASKUtally')" min-width="200" sortable>
							<template slot-scope="scope">
								<div id="" v-show="!scope.row.FILEOLDNAME">
									<el-upload style="display: inline-block;margin: 0 5px;" :action="uploadFile()" :on-success="tallySuccess" :show-file-list="false">
										<el-button class="operation_a_blue" @click="savesFBAID(scope.row)" size="small" type="text">{{ $t('message.signatureNotOrder') }}</el-button>
									</el-upload>
								</div>
								<div id="" v-show="scope.row.FILEOLDNAME">
									<span>{{ scope.row.FILEOLDNAME }}&nbsp;&nbsp;&nbsp;({{ scope.row.cnum }})</span>
									&nbsp;&nbsp;&nbsp;
									<el-button
										class="operation_a_blue el-icon-circle-close"
										style="color: red;"
										@click="BinBiaoQianFile('', '', 'tally', scope.row)"
										size="small"
										type="text"
									></el-button>
									<!-- <span @click="delfiles(scope.row)" title="点击可删除" class="el-icon-circle-close" style="color: red;"></span> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('message.containerOrderRemark')" min-width="250">
							<template slot-scope="scope">
								<div>
									<!--  :disabled="!scope.row.remarkVmodel" -->
									<el-input v-model="scope.row.REMARK" :placeholder="$t('message.containerOrderRemark')" type="text" size="medium" v-if="scope.row.remarkVmodel || isAdmin">
										<el-button slot="append" icon="el-icon-check" @click.native.prevent="setTalllyRemark(scope.row)"></el-button>
									</el-input>
									<span v-else>{{ scope.row.REMARK }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('message.goodsNo')" prop="HWDH" min-width="120"></el-table-column>
						<el-table-column :label="$t('message.amazonCode')" prop="AMAZONCODE" min-width="140"></el-table-column>
						<el-table-column :label="$t('message.caseNo')" prop="XH" min-width="80"></el-table-column>
						<el-table-column :label="$t('message.FBATagNO')" prop="BQH" min-width="120"></el-table-column>
						<el-table-column :label="$t('message.labelingRemarks')" prop="BKL" min-width="120"></el-table-column>
						<el-table-column :label="$t('message.signatureStateTitle')" prop="hasConfirm" min-width="80" sortable v-if="isAdmin"></el-table-column>
						<el-table-column :label="$t('message.downloadNumber')" prop="cot" min-width="120" sortable v-if="isAdmin"></el-table-column>
						<!--            <el-table-column :label="$t('message.customTableTitle6')" width="120">
              <template slot-scope="scope">
                <el-upload class="uploadBox" :action="uploadFile()" multiple :on-success="SKUSuccess" :show-file-list="false">
                  <el-button class="operation_a_blue" @click="savesID(scope.row)" size="small" type="text">{{ $t('message.signatureNotOrder') }}</el-button>
                </el-upload>
              </template>
            </el-table-column> -->
						<el-table-column :label="$t('message.customTableTitle5')" width="260">
							<template slot-scope="scope">
								<div class="operate_btn_box">
									<el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="loadMultipleFiles(scope.row.FILENAME, 'BQ')">
										{{ $t('message.download') }}
									</el-button>
									<!--   <el-upload style="display: inline-block;margin: 0 5px;" :action="uploadFile()" multiple :on-success="SKUSuccess" :show-file-list="false">
                    <el-button class="operation_a_blue" @click="savesID(scope.row)" size="small" type="text">{{ $t('message.signatureNotOrder') }}</el-button>
                  </el-upload>
                  <el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="delTallyFiles(scope.row.ID, 'oneOrder')" v-if="isAdmin">
                    {{ $t('message.delOrderText') }}
                  </el-button> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('message.containerCreater')" prop="DANDANGNAME" min-width="120"></el-table-column>
						<el-table-column :label="$t('message.uploadTimetext')" prop="ADDTIME" min-width="170"></el-table-column>
					</el-table>
				</div>
			</div>

			<el-dialog
				:visible.sync="uploadDialog"
				:title="$t('message.uploadReceipt')"
				destroy-on-close
				:close-on-click-modal="false"
				center
				:modal-append-to-body="false"
				width="80%"
				top="10vh"
				append-to-body
			>
				<div>
					<div class="top_search_part">
						<div class="search_box">
							<div class="search_item">
								<el-upload action="/" :show-file-list="false" :auto-upload="false" :on-change="uploadChange" :before-upload="BeforeUpload">
									<el-button icon="el-icon-upload">{{ $t('message.uploadReceipt') }}</el-button>
								</el-upload>
							</div>
						</div>
					</div>
					<div class="dialog_box" style="width: 100%;height: 400px;">
						<el-table
							id="uploadOrder"
							:data="uploadOrder"
							style="width: 100%"
							stripe
							size="small"
							header-cell-class-name="tableHeader"
							cell-class-name="tableBodyer"
							border
							height="100%"
							fit
						>
							<el-table-column :resizable="false" prop="index" :label="$t('message.customTableTitle1')" width="65"></el-table-column>
							<el-table-column prop="HWDH" :label="$t('message.goodsNo')"></el-table-column>
							<el-table-column prop="AMAZONCODE" :label="$t('message.amazonCode')"></el-table-column>
							<el-table-column prop="XH" :label="$t('message.caseNo')"></el-table-column>
							<el-table-column prop="BQH" :label="$t('message.FBATagNO')"></el-table-column>
							<el-table-column prop="SKUBQ" :label="$t('message.SKUTagNo')"></el-table-column>
							<el-table-column prop="PCS" :label="$t('message.SKUNumber')"></el-table-column>
							<el-table-column prop="SPMC" :label="$t('message.tradeName')"></el-table-column>
							<el-table-column prop="SPBK" :label="$t('message.productRemarks')"></el-table-column>
							<el-table-column prop="SPXZ" :label="$t('message.commodityPhotos')"></el-table-column>
							<el-table-column prop="BKL" :label="$t('message.labelingRemarks')"></el-table-column>
							<!-- 						<el-table-column prop="SKU" label="SKU*件数"></el-table-column>
      				<el-table-column prop="SKU2" label="SKU2*件数"></el-table-column>
      				<el-table-column prop="SKU3" label="SKU3*件数"></el-table-column>
      				<el-table-column prop="SKU4" label="SKU4*件数"></el-table-column>
      				<el-table-column prop="SKU5" label="SKU5*件数"></el-table-column> -->
						</el-table>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="uploadDialog = false">{{ $t('message.cancleText') }}</el-button>
						<el-button type="primary" @click="uploadExcel">{{ $t('message.confirmText') }}</el-button>
					</span>
				</div>
			</el-dialog>
		</el-dialog>
		<!-- FBA/SKU标签 -->
		<!-- 所有标签展示dialog -->
		<el-dialog :title="$t('message.FBASKUtally')" :visible.sync="dayTallyDialog" destroy-on-close :close-on-click-modal="false" center width="96%">
			<div class="dialog_box">
				<div class="top_search_part">
					<div class="search_box">
						<div class="search_item">
							<el-date-picker
								v-model="tallyUploadDate"
								type="daterange"
								range-separator=" - "
								:start-placeholder="$t('message.orderTimeStartHolder')"
								:end-placeholder="$t('message.orderTimeEndHolder')"
								value-format="yyyy-MM-dd"
								format="yyyy-MM-dd"
							></el-date-picker>
						</div>
						<div class="search_item" v-if="isAdmin">
							<el-select v-model="tallyTakeUse" clearable>
								<el-option v-for="manager in adminManageList" :key="manager.value" :label="manager.label" :value="manager.value"></el-option>
							</el-select>
						</div>
						<div class="search_item">
							<el-select v-model="tallyState" clearable>
								<el-option :label="$t('message.hasAffirm')" value="1"></el-option>
								<el-option :label="$t('message.notAffirm')" value="0"></el-option>
							</el-select>
						</div>
						<div class="search_item"><el-input v-model="tallyName" :placeholder="$t('message.placeholder') + $t('message.tallyName')"></el-input></div>
						<div class="search_btn" @click="searchTally">{{ $t('message.searchBtnText') }}</div>
					</div>
					<div class="search_box">
						<div class="search_btn" @click="downloadmutipleFiles">{{ $t('message.download') }}</div>
						<div class="search_btn" @click="affirmTally" v-if="isAdmin">{{ $t('message.affirmText') }}</div>
						<div class="search_btn" @click="tallyRemove" v-if="isAdmin">{{ $t('message.delOrderText') }}</div>
					</div>
				</div>
				<div class="content">
					<el-table
						id="dayTallyList"
						:data="receiptShowList"
						style="width: 100%"
						stripe
						size="small"
						header-cell-class-name="tableHeader"
						cell-class-name="tableBodyer"
						@selection-change="selectReceipt"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="80" sortable></el-table-column>
						<el-table-column :label="$t('message.FBASKUtally')" prop="FILEOLDNAME" min-width="200" sortable></el-table-column>
						<el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK" min-width="150" sortable></el-table-column>
						<el-table-column :label="$t('message.signatureStateTitle')" prop="hasConfirm" min-width="80" sortable v-if="isAdmin"></el-table-column>
						<el-table-column :label="$t('message.confirmPeople')" prop="TAKENAME" min-width="80" sortable v-if="isAdmin"></el-table-column>
						<el-table-column :label="$t('message.affirmTime')" prop="affirmTime" min-width="170" sortable v-if="isAdmin"></el-table-column>
						<el-table-column :label="$t('message.downloadNumber')" prop="downcot" min-width="80" sortable v-if="isAdmin"></el-table-column>
						<el-table-column :label="$t('message.customTableTitle5')" min-width="120">
							<template slot-scope="scope">
								<div class="operate_btn_box">
									<el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="cancelAddirm(scope.row.ID)" :disabled="!scope.row.TAKENAME">
										{{ $t('message.cancelAffirmText') }}
									</el-button>
									<el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="loadMultipleFiles(scope.row.FILENAME, 'BQ')">
										{{ $t('message.download') }}
									</el-button>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('message.containerCreater')" prop="DANDANGNAME" min-width="120"></el-table-column>
						<el-table-column :label="$t('message.uploadTimetext')" prop="ADDTIME" min-width="170"></el-table-column>
					</el-table>
				</div>
				<el-pagination
					style="position: unset;"
					@size-change="receiptSizeChange"
					@current-change="receiptCurrentChange"
					:current-page="receipt_page_no"
					:page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
					:page-size="receipt_page_size"
					layout="total, sizes, prev, pager, next"
					:total="receiptDialogList.length"
					class="tablePage"
				></el-pagination>
			</div>
		</el-dialog>
		<!-- 所有标签展示dialog -->
		<!-- 修改担当者 -->
		<el-dialog :title="$t('message.containerCreater')" :visible.sync="headerDialog" destroy-on-close :close-on-click-modal="false" center width="30%">
			<div class="dialog_box">
				<div class="dialog_row" style="margin-bottom: 100px;">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.containerCreater') }}:</span>
						<el-select v-model="headerUserid" :filterable="isAdmin" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;">
							<el-option v-for="item in adminManageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="headerDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="editHeader">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 修改担当者 -->
		<!-- 账单文件dialog -->
		<el-dialog :title="$t('message.billTitle')" :visible.sync="showBillFilesDialog" destroy-on-close :close-on-click-modal="false" center width="50%">
			<div>
				<div class="dialog_row">
					<div class="dialog_item" style="display: flex;justify-content: center;">
						<el-upload class="uploadBox" :action="uploadFile()" multiple :on-success="billFilesSuccess" :on-remove="billFilesRemove" :file-list="receiptList">
							<!--  :file-list="attacherFile" -->
							<el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
						</el-upload>
					</div>
					<div class="dialog_item" style="display: flex;flex-direction: column;align-items: center;">
						<div v-for="(file, index) in receiptList" :key="index">
							<span>{{ file.FILEOLDNAME }}</span>
							<el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file, 'ZD')">{{ $t('message.download') }}</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 账单文件dialog -->
		<!-- 修改车牌号及司机 -->
		<el-dialog :title="$t('message.CarNoTitle')" :visible.sync="CarDialog" destroy-on-close :close-on-click-modal="false" center width="30%">
			<div class="dialog_box">
				<div class="dialog_row" style="margin-bottom: 100px;">
					<div class="dialog_item"><el-input class="dialog_item_input" :placeholder="$t('message.CarAndSiJiTitle')" v-model="CarAndSiJI"></el-input></div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="CarDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="editCarNum">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 修改车牌号及司机 -->
		
		
		<!-- 上传4KWS1订单 -->
		<el-dialog :title="$t('message.orderTemplateUploadTitle')" :visible.sync="showUpload" width="40%" destroy-on-close :close-on-click-modal="false">
		  <div>
		    <div class="dialog_row">
		      <div class="dialog_item">
		        <span class="dialog_item_title">{{$t('message.containerJOBNO')}}：</span>
					<el-input v-model="JOBNO4K" :placeholder="$t('message.placeholder')"></el-input>		        
		      </div>
		    </div>
		    <div class="dialog_row">
		      <div class="dialog_item">
		        <span class="dialog_item_title">{{$t('message.chaiguiTime')}}：</span>
		        <el-date-picker v-model="deliveryDate4K" type="date" :editable="false" :clearable="false" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="margin-right: 10px;flex-shrink: 0;" ></el-date-picker>
		      </div>
		    </div>
		    <div class="dialog_row">
		      <div class="dialog_item">
		        <span class="dialog_item_title">{{$t('message.containerOrderCustomerID')}}：</span>
		        <el-select v-model="customerSel4K" :filterable="isAdmin" :placeholder="$t('message.exportDatePlaceholder')" style="flex-grow: 1;">
		        	<el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.label + ',' + item.value"></el-option>
		        </el-select>
		      </div>
		    </div>
			<div class="dialog_row">
			  <div class="dialog_item">
				<span class="dialog_item_title">{{$t('message.uploadFileTitle')}}：</span>
				<el-upload :action="uploadUrl" :limit="1" :on-change="uploadChange4k" :on-success="handleSuccess4k" :on-remove="handleRemove4k" style="margin-left: 20px;display: flex;align-items: baseline;">
				  <el-button class="add_btn" icon="el-icon-upload">{{$t('message.importExcelTitle')}}</el-button>
				</el-upload>
			  </div>
			</div>
		    <span slot="footer" class="dialog-footer">
		      <el-button @click="showUpload = false">{{$t('message.cancleText')}}</el-button>
		      <el-button type="primary" @click="uploadOrderFile" :disabled="!this.importFile">{{$t('message.orderTemplateUploadTitle')}}</el-button>
		    </span>
		  </div>
		</el-dialog>
		<!-- 上传4KWS1订单 -->
		
		
		<!-- 修改货物状态 -->
		<el-dialog :title="$t('message.goodsStatus')" :visible.sync="goodsStatusDialog" destroy-on-close :close-on-click-modal="false" center width="30%">
			<div class="dialog_box">
				<div class="dialog_row" style="margin-bottom: 100px;">
					<div class="dialog_item">
						<el-radio-group v-model="goodsStatusSelect" style="flex-shrink: 0;margin-right: 30px;">
							<el-radio label="0">{{ $t('message.weicaozuoTitle') }}</el-radio>
							<el-radio label="1">{{ $t('message.yididaTitle') }}</el-radio>
							<el-radio label="2">{{ $t('message.yianpaiTitle') }}</el-radio>
							<el-radio label="3">{{ $t('message.yiwanchengTitle') }}</el-radio>
						</el-radio-group>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" style="margin-top: 200px;">
					<el-button @click="goodsStatusDialog = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="SavegoodsStatus">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 修改货物状态 -->
	</div>
</template>

<script>
import {
	getContainerOrder,
	uploadImg,
	setContainerOrder,
	checkAttachment,
	imgSrc,
	delContainerOrder,
	updateContainerStatus,
	updateXuKe,
	exportContainerOrder,
	getKansaiReceipt,
	setKansaiReceipt,
	delKansaiReceipt,
	getKantoReceipt,
	setKantoReceipt,
	delKantoReceipt,
	getReturnReceipt,
	setReturnReceipt,
	delReturnReceipt,
	sendContainerEmail,
	getOneDayKansaiReceipt,
	getOneDayKantoReceipt,
	getOneDayReturnReceipt,
	loadMultipleFiles,
	HTTPS,
	getCustomer,
	getTallyFile,
	setTallyFile,
	delTallyFile,
	getDayTallyFile,
	affirmTallyFile,
	setTallyFileRemark,
	editHeader,
	getBillFiles,
	setBillFiles,
	delBillFiles,
	UpDataCarAndDriver,
	editCarNum,
	setSKUTallyFile,
	delSKUTallyFile,
	getSKUTallyFile,
	getQrCode,
	DelBiaoQianLst,
	SetBiaoQianLst,
	BinBiaoQianFile,
	BinBiaoQianDtFile,
	BianQianQrPage,
	ExportWlBiaoQian,
	DownloadFile,
	setprintContainerOrder
} from '@/api/getData.js';
import XLSX from 'xlsx';
export default {
	name: 'containerOrder',
	data() {
		return {
			getRowKeys(row) {
				// console.log("111111",row);
				return row.ID;
			},
			expands: [],
			isAdmin: false,
			specialIdentity: '',
			date: '',
			city: '',
			page_no: 1,
			page_size: 50,
			pageSizes: [20, 50, 100, 200, 500, 1000],
			totalSize: 0,
			prop: null, // 排序字段
			order: '', // 排序方式
			orderList: [],
			showDialog: false,
			dialogTitle: '',
			newOrder: 0,
			saveSelectTHDZ: '',
			cityVal: '',
			JOBNO: '', // JHSS 工作号
			JOBNO4K:'',//4kws1 JHSS 工作号
			JOBNOCanInput: false, // JHSS 工作号是否可输入
			containerModel: '', // 集装箱型号
			containerCodeType: '', // 集装箱型号选为 【集装箱】 之后，集装箱编码类型
			containerCoding: '', // 集装箱编码
			placeofCity: '', // 提货地点选择城市
			containerTrailerCity: '', // 集装箱拖车安排
			trailerLocation: '', //集装箱拖车安排地址
			placeOfDelivery: '', // 提货地点详细地址
			arrivalDate: '', // 抵达日期
			delayDate: '', // 到达日期
			deliveryDate: '', // 提货日期
			deliveryDate4K:'',
			hasSpecifyTime: false, // 提货日期有无指定时间
			specifyTime: '', // 提货日期指定时间
			customerLsit: [], // 客户列表
			customerSel: '', // 客户选择列表
			customerSel4K:'',
			containerCustomer: '', // 客人
			dedicatedNum: '', // 客户专用编号
			containerNumber: '', // 数量
			containerNumberUnit: '', // 数量单位
			containerVolume: '', // 体积
			containerWeight: '', // 重量
			goldMoney: '', // 立替金
			remark: '', // 备注
			inspection: [], // 查验
			attacherFile: [], // 上传文件
			cityOptions: ['東京', '大阪'],
			showAttachment: false,
			attachmentList: [],
			showKantoDialog: false,
			showKansaiDialog: false,
			showReturnReceiptDialog: false,
			showBillFilesDialog: false,
			tallyDialog: false,
			receiptPid: 0,
			receiptList: [],
			SKUList: [],
			receiptDialogTitle: '', // 关东、关西 签收单 dialog---title
			receiptDialog: false, // 关东、关西 签收单 显示
			receiptDialogList: [], // 关东、关西签收单列表
			receiptSelectTable: [], // 签收单下载列表
			receipt_page_no: 1,
			receipt_page_size: 10,
			dayTallyDialog: false, // 当日标签下载列表显示
			tallyUploadDate: null, // 标签上传日期
			tallyName: '', // 标签名称
			adminManageList: [], // 确认人列表
			tallyTakeUse: '', // 确认人
			tallyState: '0', // 是否已确认
			headerDialog: false, // 变换担当者dialog
			headerID: 0, // 当前订单id
			headerUserid: '', // 担当者userid
			CarDialog: false,
			goodsStatusDialog:false,
			CarAndSiJI: '',
			CarAndSiJIID: 0,
			FBAID: 0,
			SKUID: 0,
			queryTallyID: [],
			isImportComp: true,
			uploadDialog: false,
			uploadOrder: [],
			innerVisible:false,
			fileArr:[],
			showUpload: false, //上传4KWS1弹窗			
			importOrder: [],	//4KWS1订单
			importFile: '',
			containerxuke:'未許可',//是否许可
			goodsStatusId:0,
			goodsStatusSelect:''
		};
	},
	created() {
		this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin');
		this.specialIdentity = this.$store.state.JHSS.personalUserid !== 'administrator' ? this.$store.state.JHSS.personalSpecial : 'administrator';
		this.date = this.$route.query.date;
		this.tallyUploadDate = [this.$route.query.date, this.$route.query.date];
		this.city = this.$route.query.city;
		this.delayDate = this.date;
		this.deliveryDate4K=this.date;
		this.deliveryDate=this.date;
		console.log("deliveryDate",this.deliveryDate);
		if (this.isAdmin) {
			this.getCustomer();
		} else {
			this.customerLsit = [
				{
					label: this.$store.state.JHSS.personalAccount + '——' + this.$store.state.JHSS.personalCompany,
					value: this.$store.state.JHSS.personalUserid
				}
			];
		}
		this.getContainerOrder();
	},
	methods: {
		changeLeixing(e){
			console.log("e",e);
			if(e=="4KWS1"||e=="2SWH7"){
				if(this.city=="藤井寺"){this.placeOfDelivery="JHSS藤井寺・保税・4KWS1";}
				if(this.city=="市川"){this.placeOfDelivery="JHSS市川・保税・2SWH7";}
				
			}else{				
				if(e=="1FWX6"){
					if(this.city=="大田"){this.placeOfDelivery="大田保税倉庫";}					
				}else{				
					this.placeOfDelivery="";
				}
			}
		},
		uploadExceed(){
			this.$message({
          showClose: true,
          message: '最大上传数量为5',
          type: 'warning'
        });
		},
		clearFiles(){
			console.log("关闭弹窗");
			this.$refs['my-upload'].clearFiles();
			this.fileArr = []
		},
		beforeUploadFile(file){
			// const isLt10M = file.size / 1024 / 1024 < 10;
			// if (!isLt10M) {
			// 	return false;
			// }
			// this.fileArr=[]
			this.innerVisible=true;
		},
		//文件上传过程当中的函数(在这里获取进度条的进度)
		uploadFileProcess(event, file, fileList){
			// console.log(event,file,fileList);
			this.fileArr = fileList
			this.fileArr.forEach(item=>{
				// console.log(item.percentage);
				if (item.percentage ==100) {
					// item.successFlag=true
					// item.progressFlag = false
				} else {
					item.progressPercent = Math.abs(item.percentage.toFixed(0));
					item.progressFlag = true

				}
			})
		},
		goBack() {
			this.$router.go(-1);
		},

		// handleRemove(file, fileList) {
		//   console.log(file, fileList);
		// },
		delfiles(row) {
			// console.log(row);
		},
		// //显示集装箱拖车方式
		// showContainerOption(){
		// 	console.log(this.containerTrailerCity)
		// },

		// 查询客户列表
		async getCustomer() {
			let param = { IFQUERY: '1' };
			let res = await getCustomer(param);
			let resadmin = await getCustomer();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			} else {
				//console.log(res.data.dt)
				let list = res.data.dt.map(item => {
					return {
						label: item.USHOWNAME + '——' + item.GUDING1,
						value: item.USERID
					};
				});
				let listadmin = resadmin.data.dt.map(item => {
					return {
						label: item.USHOWNAME + '——' + item.GUDING1,
						value: item.USERID
					};
				});
				this.customerLsit = list.filter(item => {
					if (!item.value.includes('admin')) {
						return item;
					}
				});
				this.adminManageList = listadmin.filter(item => {
					if (item.value.includes('admin')) {
						return item;
					}
				});
			}
		},
		// 查询集装箱订单
		async getContainerOrder() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { DADATE: this.date, CITY: this.city, PAGE: this.page_no, TYPE: this.page_size, ADDUSERID: this.$store.state.JHSS.personalUserid };
			if (this.prop) param.ORDERNAME = this.prop;
			param.DOA = this.order;
			let res = await getContainerOrder(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			// console.log(res.data)
			this.totalSize = res.data.num;
			let _this = this;
			let index = 0;
			this.orderList = res.data.dt.map(item => {
				// console.log('item', item);
				item.index = ++index;
				item.arrivalTime = item.DATIME + ' ' + item.DADATE;
				let city = !item.THCITY ? '' : item.THCITY;
				let address = !item.THDIZHI ? '' : item.THDIZHI;
				item.placeOfDelivery = city + ' ' + address;
				// item.containerTrailerCity=!item.TCAP ? '' : item.TCAP;
				// trailerLocation=!item.TCAPDZ ? '' : item.TCAPDZ;
				// let city = !item.THCITY ? '' : item.THCITY;
				// let address = !item.THDIZHI ? '' : item.THDIZHI;

				let date = !item.THDATE ? '' : item.THDATE;
				let assign = !item.DDDATE ? '' : item.DDDATE;
				item.deliveryDate = date + ' ' + assign;
				item.addTime = item.ADDTIME.replace(/T/g, ' ');
				item.customerId = !item.CUSTOMERID ? '' : item.CUSTOMERID.split(',')[0];
				if (item.GUDING3 === null || item.GUDING3 === '') {
					item.goodsStatus = _this.$t('message.setGoodsStatus');
				} else if (item.GUDING3 === '0') {
					item.goodsStatus = _this.$t('message.weicaozuoTitle');
				} else if (item.GUDING3 === '1') {
					item.goodsStatus = _this.$t('message.yididaTitle');
				} else if (item.GUDING3 === '2') {
					item.goodsStatus = _this.$t('message.yianpaiTitle');
				} else if (item.GUDING3 === '3') {
					item.goodsStatus = _this.$t('message.yiwanchengTitle');
				} else {
					item.goodsStatus = _this.$t('message.hasArrive');
				}
				if (item.GUDING4 === null || item.GUDING4 === '') {
					item.condition = _this.$t('message.setGoodsStatus');
				} else if (item.GUDING4 === '0') {
					item.condition = _this.$t('message.abnormalCondition');
					// + (!item.GUDING5 ? '' : ': ' + item.GUDING5)
				} else {
					item.condition = _this.$t('message.normalCondition');
				}
				return item;
			});
		},
		saveSelectTH(val) {
			this.saveSelectTHDZ = val;
		},
		sizeChange(val) {
			this.page_size = val;
			this.getContainerOrder();
		},
		currentChange(val) {
			this.page_no = val;
			this.getContainerOrder();
		},
		// 排序
		sortChange(obj) {
			// console.log(obj)
			// 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
			this.prop = null;
			if (obj.prop === 'arrivalTime') {
				this.prop = 'DADATE,DATIME';
			}
			if (obj.prop === 'JZXSIZE') {
				this.prop = 'JZXSIZE';
			}
			this.order = '';
			if (obj.order === 'descending') {
				this.order = 'DESC';
			}
			if (!obj.order) {
				this.prop = null;
			}
			this.getContainerOrder();
		},
		// 新建订单
		addNewOrder() {
			this.newOrder = 0;
			this.JOBNOCanInput = this.isAdmin;
			// this.cityVal = ''
			this.delayDate = this.date;
			this.deliveryDate=this.date;
			this.hasSpecifyTime = false;
			this.customerSel = !this.isAdmin ? this.customerLsit[0].label + ',' + this.customerLsit[0].value : '';
			this.containerCustomer = !this.isAdmin ? this.$store.state.JHSS.personalAccount : '';
			this.inspection = [];
			this.attacherFile = [];
			this.JOBNO = this.containerModel = this.containerCodeType = this.containerCoding = this.placeofCity = this.containerTrailerCity = this.trailerLocation = this.placeOfDelivery = this.arrivalDate = this.specifyTime =
				'';
			this.dedicatedNum = this.containerNumber = this.containerNumberUnit = this.containerVolume = this.containerWeight = this.goldMoney = this.remark = '';
			this.dialogTitle = this.$t('message.newContainerTitle');
			this.showDialog = true;
			this.containerxuke='未許可';
			// console.log('输出', this.containerTrailerCity, this.trailerLocation);
		},
		// 发送邮件
		sendEmail(userid, id) {
			let _this = this;
			this.$confirm('', _this.$t('message.sendEmailPeompt'), {
				// showClose: false,
				distinguishCancelAndClose: true,
				closeOnClickModal: false,
				closeOnPressEscape: false,
				center: true,
				callback: async action => {
					if (action === 'confirm') {
						const loading = _this.$loading({
							lock: true,
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						let param = { USERID: userid, JZXID: id };
						let res = await sendContainerEmail(param);
						loading.close();
						if (res.status !== 200) {
							_this.$message.error('network error：' + res.status);
						} else if (res.data.result !== '1') {
							_this.$message.error(res.data.message);
						} else {
							_this.$message.success('Send Success');
						}
					}
				}
			});
		},
		// 修改订单
		async updateOrder(obj) {
			this.showDialog = true;
			this.dialogTitle = this.$t('message.modifyContainerTitle');
			this.newOrder = obj.ID;
			// this.cityVal = ''
			this.JOBNO = obj.JOBNO;
			this.JOBNOCanInput = this.isAdmin && !obj.JOBNO;
			this.containerModel = !obj.JZXSIZE.includes('GP/HQ') ? obj.JZXSIZE : '集装箱';
			this.containerCodeType = !obj.JZXSIZE.includes('GP/HQ') ? '' : obj.JZXSIZE;
			this.containerCoding = obj.JZXNUM;
			this.placeofCity = obj.THCITY;
			this.containerTrailerCity = obj.TCAP;
			this.trailerLocation = obj.TCAPDZ;
			this.placeOfDelivery = obj.THDIZHI;
			this.arrivalDate = obj.DATIME;
			this.delayDate = obj.DADATE;
			this.deliveryDate = obj.THDATE;
			this.hasSpecifyTime = obj.DDDATE !== '';
			this.specifyTime = obj.DDDATE;
			this.customerSel = obj.CUSTOMERID;
			this.containerCustomer = obj.KEREN;
			this.dedicatedNum = obj.KRZYBH;
			this.containerNumber = obj.SHULIANG.split(' ')[0];
			this.containerNumberUnit = obj.SHULIANG.split(' ')[1];
			this.containerVolume = obj.TIJI.split(' ')[0];
			this.containerWeight = obj.ZHONGLIANG.split(' ')[0];
			this.goldMoney = obj.LITIJIN;
			this.remark = obj.REMARK;
			
			this.containerxuke=obj.GUDING5;
			
			this.inspection = !obj.GPJC ? [] : obj.GPJC.split('、');
			let param = { PID: obj.ID };
			let res = await checkAttachment(param);
			this.attacherFile = res.data.dt.map(item => {
				item.name = item.FILEOLDNAME;
				item.url = imgSrc(item.FILENAME);
				return item;
			});
		},
		// 附加文件上传成功
		handleSuccess(file, fileList) {
			// console.log('success', fileList);
			let listF = this.attacherFile;
			listF.push({
				name: fileList.response.data.fileoldname,
				url: imgSrc(fileList.response.data.filename),
				FILENAME: fileList.response.data.filename,
				FILEOLDNAME: fileList.response.data.fileoldname
			});
			this.attacherFile = listF;
			// console.log('list', listF);
		},
		// 删除附加文件
		handleRemove(file, fileList) {
			// console.log('remove', fileList)
			if (this.newOrder === 0) {
				let list = [];
				for (let i = 0; i < fileList.length; i++) {
					let obj = {
						name: fileList[i].response.data.fileoldname,
						url: imgSrc(fileList[i].response.data.filename),
						FILENAME: fileList[i].response.data.filename,
						FILEOLDNAME: fileList[i].response.data.fileoldname
					};
					list.push(obj);
				}
				this.attacherFile = list;
			} else {
				this.attacherFile = fileList;
			}
		},
		// 添加或修改集装箱订单
		async addNewConfirm() {
			if (!this.containerModel) {
				this.$message(this.$t('message.containerGoodsModel'));
			} else if (this.containerModel === '集装箱' && (!this.containerCodeType || !this.containerCoding)) {
				this.$message(this.$t('message.containerOrderNumber'));
			} else if (this.containerNumber && !this.containerNumberUnit) {
				this.$message(this.$t('message.numberUnitPlaceholder'));
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					main: {
						ID: this.newOrder,
						CITY: this.city,
						JOBNO: this.JOBNO,
						JZXSIZE: this.containerModel === '集装箱' ? this.containerCodeType : this.containerModel,
						JZXNUM: this.containerCoding,
						DADATE: this.delayDate,
						DATIME: this.arrivalDate,
						THCITY: this.placeofCity,
						TCAP: this.containerTrailerCity,
						TCAPDZ: this.trailerLocation,
						THDIZHI: this.placeOfDelivery,
						THDATE: this.deliveryDate,
						DDDATE: this.specifyTime,
						CUSTOMERID: this.customerSel,
						KEREN: this.containerCustomer,
						KRZYBH: this.dedicatedNum,
						SHULIANG: !this.containerNumber ? '' : this.containerNumber + ' ' + this.containerNumberUnit,
						TIJI: !this.containerVolume ? '' : this.containerVolume + ' m³',
						ZHONGLIANG: !this.containerWeight ? '' : this.containerWeight + ' KGS',
						LITIJIN: this.goldMoney,
						REMARK: this.remark,
						GPJC: this.inspection.join('、'),
						GUDING5:this.containerxuke
					},
					lst: this.attacherFile
				};
				if (this.containerModel === '集装箱') {
					delete param.main.THCITY;
					delete param.main.THDIZHI;
					delete param.main.THDATE;
					delete param.main.DDDATE;
					if (param.main.TCAP != this.$t('message.containerTransportWays3')) {
						param.main.TCAPDZ = '';
					}
				} else {
					delete param.main.JZXNUM;
				}
				if (this.newOrder === 0) {
					param.main.ADDUSER = this.$store.state.JHSS.personalUserid;
					param.main.GUDING1 = this.$store.state.JHSS.personalAccount;
				} else {
					param.main.EDITUSER = this.$store.state.JHSS.personalUserid;
					param.main.GUDING2 = this.$store.state.JHSS.personalAccount;
				}
				let res = await setContainerOrder(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
				} else if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.showDialog = false;
					this.page_no = this.newOrder === 0 ? 1 : this.page_no;
					this.getContainerOrder();
				}
			}
		},
		// 查看附件
		async checkFiles(id) {
			let param = { PID: id };
			let res = await checkAttachment(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				if (res.data.dt.length === 0) {
					this.$message(this.$t('message.noAttachment'));
				} else {
					this.attachmentList = res.data.dt.map(item => {
						item.url = imgSrc(item.FILENAME);
						return item;
					});
					this.showAttachment = true;
				}
			}
		},
		// 删除集装箱订单
		delOrder(id) {
			this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.del(id);
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		//更新签收单打印
		SetOrderPrint(id, AreaType) {
			this.$confirm(this.$t('message.setPPrompt'), this.$t('message.promptTitle'), {
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.setprint(id, AreaType);
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		async del(id) {
			let param = { ID: id };
			let res = await delContainerOrder(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.page_no = 1;
				this.getContainerOrder();
			}
		},
		async setprint(id, AreaType) {
			let param = { ID: id };
			if (AreaType == 'GDQSDUSER') {
				param = { ID: id, GDQSDUSER: this.$store.state.JHSS.personalUserid, GDQSDNAME: this.$store.state.JHSS.personalAccount };
			} else {
				param = { ID: id, GXQSDUSER: this.$store.state.JHSS.personalUserid, GXQSDNAME: this.$store.state.JHSS.personalAccount };
			}
			let res = await setprintContainerOrder(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.page_no = 1;
				this.getContainerOrder();
			}
		},
		// 修改货物抵达状况
		updateGoodsStatus(id,guding3) {
			this.goodsStatusDialog=true;
			this.goodsStatusId=id;
			if(guding3==null || guding3=="")
			{
				this.goodsStatusSelect ="0";
			}else{
				this.goodsStatusSelect =guding3;
			}
			// let _this = this;
			// this.$confirm('', _this.$t('message.goodsStatus'), {
			// 	// showClose: false,
			// 	distinguishCancelAndClose: true,
			// 	closeOnClickModal: false,
			// 	closeOnPressEscape: false,
			// 	center: true,
			// 	confirmButtonText: _this.$t('message.hasArrive'),
			// 	cancelButtonText: _this.$t('message.notArrive'),
			// 	callback: action => {
			// 		if (action === 'confirm') {
			// 			_this.setGoodsStatus({ ID: id, GUDING3: 1 });
			// 		} else if (action === 'cancel') {
			// 			_this.setGoodsStatus({ ID: id, GUDING3: 0 });
			// 		}
			// 	}
			// });
		},
		//保存货物状态
		SavegoodsStatus(){
			let _this = this;
			_this.setGoodsStatus({ ID: this.goodsStatusId, GUDING3: this.goodsStatusSelect });
		},
		// 修改许可状况
		updateXuKeStatus(id,jsize) {
			let _this = this;
			
			//if(this.city=="藤井寺"||this.city=="市川"){
				// this.$confirm('', _this.$t('message.XuKeText'), {
				// 	// showClose: false,
				// 	cancelButtonClass: 'btn-custom-cancel',
				// 	distinguishCancelAndClose: true,
				// 	closeOnClickModal: false,
				// 	closeOnPressEscape: false,
				// 	center: true,
				// 	confirmButtonText: _this.$t('message.NoXuKeText'),
				// 	cancelButtonText: _this.$t('message.HaveXuKeText'),
				// 	callback: action => {
				// 		if (action === 'confirm') {
				// 			_this.setXuKeStatus({ ID: id, GUDING3: 0,JZXSIZE: jsize});
				// 		} else if (action === 'cancel') {
				// 			_this.setXuKeStatus({ ID: id, GUDING3: 1,JZXSIZE: jsize });
				// 		}
				// 	}
				// });
			// }else
			// {
				this.$confirm('', _this.$t('message.XuKeText'), {
					// showClose: false,
					distinguishCancelAndClose: true,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					center: true,
					cancelButtonText: _this.$t('message.NoXuKeText'),
					confirmButtonText: _this.$t('message.HaveXuKeText'),
					callback: action => {
						if (action === 'confirm') {
							_this.setXuKeStatus({ ID: id, GUDING3: 1,JZXSIZE: jsize });
						} else if (action === 'cancel') {
							_this.setXuKeStatus({ ID: id, GUDING3: 0,JZXSIZE: jsize });
						}
					}
				});
			// }
			
			
		},
		// 修改司机、车牌
		updateSiJi(id) {
			this.CarAndSiJIID = id;
			this.CarDialog = true;
			this.CarAndSiJI = '';
		},
		async setGoodsStatus(param) {
			let res = await updateContainerStatus(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.getContainerOrder();
			}
		},
		async setXuKeStatus(param) {
			let res = await updateXuKe(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.getContainerOrder();
			}
		},
		async editCarNum() {
			let param = { ID: this.CarAndSiJIID, CARADNDRIVER: this.CarAndSiJI };
			let res = await UpDataCarAndDriver(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.CarDialog = false;
				this.getContainerOrder();
			}
		},
		// 导出
		async exportContainerOrders() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { CITY: this.city, JZXSIZE: '', DADATE: this.date, ADDUSERID: this.$store.state.JHSS.personalUserid };
			let res = await exportContainerOrder(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				// console.log(res.data)
				let str = HTTPS + '/xlsx/' + res.data;
				window.open(str);
			}
		},
		// 查看关东签收单
		checkKantoReceipt(id) {
			this.checkFilesReceipt(id, 'kanto');
		},
		// 查看关西签收单
		checkKansaiReceipt(id) {
			this.checkFilesReceipt(id, 'kansai');
		},
		// 查看回传签收单
		checkReturnReceipt(id) {
			this.checkFilesReceipt(id, 'returnReceipt');
		},
		// 查看账单 （权限控制：只有超级管理员、上传文件人员、订单创建人员可见）
		checkBills(id) {
			this.checkFilesReceipt(id, 'bills');
		},

		// 查看签收单文件
		async checkFilesReceipt(id, type) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { PID: id };
			let res = {};
			if (type === 'kanto') {
				res = await getKantoReceipt(param);
			} else if (type === 'kansai') {
				res = await getKansaiReceipt(param);
			} else if (type === 'returnReceipt') {
				res = await getReturnReceipt(param);
			} else if (type === 'tally') {
				res = await getTallyFile(param);
			} else if (type === 'bills') {
				param.ADDUSERID = this.$store.state.JHSS.personalUserid;
				res = await getBillFiles(param);
			}
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				this.receiptList = res.data.dt.map(item => {
					item.name = item.FILEOLDNAME + (item.DOWNTIME ? " " + item.DOWNTIME.replace(/T/g, ' ') : "")
					item.FILEOLDNAME = item.name
					// item.name = item.FILEOLDNAME;
					item.url = imgSrc(item.FILENAME);
					return item;
				});
				this.receiptPid = id;
				// console.log(this.receiptPid);

				if (type === 'kanto') {
					this.showKantoDialog = true;
				} else if (type === 'kansai') {
					this.showKansaiDialog = true;
				} else if (type === 'returnReceipt') {
					this.showReturnReceiptDialog = true;
				} else if (type === 'tally') {
					let index = 0;
					this.receiptList = this.receiptList.map(item => {
						item.index = ++index;
						item.hasConfirm = !item.TAKENAME ? '' : '√';
						item.remarkVmodel = !item.REMARK;
						item.ADDTIME = item.ADDTIME.replace(/T/g, ' ');
						// item.SKUList=SKUList
						return item;
					});

					this.tallyDialog = true;
				} else if (type === 'bills') {
					this.showBillFilesDialog = true;
				}
			}
		},
		// 关东签收单上传成功
		kantoSuccess(file) {
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR');
			} else {
				this.fileUploadSuccess(file.data.filename, file.data.fileoldname, 'kanto');
			}
		},
		// 关西签收单上传成功
		kansaiSuccess(file) {
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR');
			} else {
				this.fileUploadSuccess(file.data.filename, file.data.fileoldname, 'kansai');
			}
		},
		// 回传签收单上传成功
		returnReceiptSuccess(file) {
			// console.log('returnReceiptSuccess', file)
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR');
			} else {
				this.fileUploadSuccess(file.data.filename, file.data.fileoldname, 'returnReceipt');
			}
		},
		// 账单文件上传成功
		billFilesSuccess(file) {
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR');
			} else {
				this.fileUploadSuccess(file.data.filename, file.data.fileoldname, 'bills');
			}
		},
		// 文件上传成功，绑定id与文件
		async fileUploadSuccess(filename, fileoldname, type) {
			let param = { PID: this.receiptPid, FILENAME: filename, FILEOLDNAME: fileoldname };
			// console.log(param);
			let res = {};
			if (type === 'kanto') {
				res = await setKantoReceipt(param);
			} else if (type === 'kansai') {
				res = await setKansaiReceipt(param);
			} else if (type === 'returnReceipt') {
				res = await setReturnReceipt(param);
			} else if (type === 'tally') {
				param.ADDUSER = this.$store.state.JHSS.personalUserid;
				param.DANDANGUSER = this.$store.state.JHSS.personalUserid;
				param.DANDANGNAME = this.$store.state.JHSS.personalAccount;
				res = await setTallyFile(param);
			} else if (type === 'bills') {
				param.ADDUSERID = this.$store.state.JHSS.personalUserid;
				res = await setBillFiles(param);
			} else if (type === 'skutally') {
				param = { PID: this.FBAID, ID: 0, FILENAME: filename, FILEOLDNAME: fileoldname };
				res = await setSKUTallyFile(param);
			}

			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				this.$message.success('UPLOAD SUCCESS');
				if (type === 'kanto') {
					this.checkKantoReceipt(this.receiptPid);
				} else if (type === 'kansai') {
					this.checkKansaiReceipt(this.receiptPid);
				} else if (type === 'returnReceipt') {
					this.checkReturnReceipt(this.receiptPid);
				} else if (type === 'tally') {
					this.checkFBASKUtally(this.receiptPid);
				} else if (type === 'bills') {
					this.checkBills(this.receiptPid);
				} else if (type === 'skutally') {
					this.checkSKUtally(this.FBAID);
				}
				this.getContainerOrder();
			}
		},
		// 关东签收单删除
		kantoRemove(file) {
			this.fileRemove(file.ID, 'kanto');
		},
		// 关西签收单删除
		kansaiRemove(file) {
			this.fileRemove(file.ID, 'kansai');
		},
		// 回传签收单删除
		returnReceiptRemove(file) {
			// console.log('returnReceiptRemove', file)
			if (!this.isAdmin) {
				return;
			} else {
				this.fileRemove(file.ID, 'returnReceipt');
			}
		},
		// 账单文件删除
		billFilesRemove(file) {
			this.fileRemove(file.ID, 'bills');
		},
		// 文件删除
		async fileRemove(id, type) {
			let param = { ID: id };
			let res = {};
			if (type === 'kanto') {
				res = await delKantoReceipt(param);
			} else if (type === 'kansai') {
				res = await delKansaiReceipt(param);
			} else if (type === 'returnReceipt') {
				res = await delReturnReceipt(param);
			} else if (type === 'bills') {
				res = await delBillFiles(param);
			}
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				this.$message.success('DELETE SUCCESS');
				if (type === 'kanto') {
					this.checkKantoReceipt(this.receiptPid);
				} else if (type === 'kansai') {
					this.checkKansaiReceipt(this.receiptPid);
				} else if (type === 'returnReceipt') {
					this.checkReturnReceipt(this.receiptPid);
				} else if (type === 'bills') {
					this.checkBills(this.receiptPid);
				}
				this.getContainerOrder();
			}
		},
		// 查看订单明细
		checkContainerOrders(obj) {
			this.$router.push({ path: '/amazonOrderManage', query: { ID: obj.ID, customerID: obj.CUSTOMERID } });
		},
		// 查看当天签收单 -- 关东/关西/标签
		async kanto_kansai_receipt(type) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = { DADATE: this.date, CITY: this.city, ADDUSERID: this.$store.state.JHSS.personalUserid };
			let res = {};
			if (type === 'kanto') {
				res = await getOneDayKantoReceipt(param);
			} else if (type === 'kansai') {
				res = await getOneDayKansaiReceipt(param);
			} else if (type === 'return') {
				res = await getOneDayReturnReceipt(param)
			} else if (type === 'tally') {
				// param.DADATE = this.tallyUploadDate
				this.tallyUploadDate = [this.$route.query.date, this.$route.query.date];
				this.tallyState = '0';
				param.UADDDATE = this.tallyUploadDate[0] + ' 00:00:00';
				param.DADDDATE = this.tallyUploadDate[1] + ' 23:59:59';
				param.state = this.tallyState;
				res = await getDayTallyFile(param);
			}
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				// console.log(res.data)
				let index = 0;
				this.receiptDialogList = res.data.dt.map(item => {
					item.index = ++index;
					item.href = imgSrc(item.FILENAME);
					item.name = item.FILEOLDNAME;
					return item;
				});
				this.receiptSelectTable = [];
				this.receipt_page_no = 1;
				this.receipt_page_size = 10;
				if (type === 'kanto') {
					this.receiptDialog = true;
					this.receiptDialogTitle = this.$t('message.kantoReceipt');
				} else if (type === 'kansai') {
					this.receiptDialog = true;
					this.receiptDialogTitle = this.$t('message.kansaiReceipt');
				}  else if (type === 'return') {
					this.receiptDialog = true;
					this.receiptDialogTitle = this.$t('message.containerReturnReceipt');
				} else if (type === 'tally') {
					this.receiptDialogList = this.receiptDialogList.map(item => {
						item.hasConfirm = !item.TAKENAME ? '' : '√';
						item.affirmTime = !item.TAKETIME ? '' : item.TAKETIME.replace(/T/g, ' ');
						item.ADDTIME = item.ADDTIME.replace(/T/g, ' ');
						return item;
					});
					this.dayTallyDialog = true;
					this.receiptDialogTitle = this.$t('message.FBASKUtally');
					this.tallyName = this.tallyTakeUse = '';
				}
			}
		},
		selectReceipt(val) {
			this.receiptSelectTable = val;
		},
		// 单个附加文件下载
		async downLoadAttachmentFile(file, type) {
			this.loadMultipleFiles(file.FILENAME, type);
		},
		// 关东签收单、关西签收单、标签下载
		async downloadmutipleFiles() {
			if (this.receiptSelectTable.length === 0) {
				this.$message(this.$t('message.exportDatePlaceholder'));
			} else {
				let type = '';
				if (this.receiptDialogTitle === this.$t('message.kantoReceipt')) {
					type = 'GD';
				} else if (this.receiptDialogTitle === this.$t('message.kansaiReceipt')) {
					type = 'GX';
				} else if (this.receiptDialogTitle === this.$t('message.containerReturnReceipt')) {
					type = 'HCD';
				} else if (this.receiptDialogTitle === this.$t('message.FBASKUtally')) {
					type = 'BQ';
				}
				let list = this.receiptSelectTable.map(item => {
					return item.FILENAME;
				});
				this.loadMultipleFiles(list.join(','), type);
			}
		},
		// 下载文件（多个文件压缩，或者单个文件直接下载）
		async loadMultipleFiles(filename, type) {
			// console.log(filename);

			if (!filename) {
				this.$message.error(this.$t('message.noAttachment'));
				return;
			}
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				FILENAME: filename,
				FILETYPE: type,
				DOWNLOADUSER: this.$store.state.JHSS.personalUserid
			};
			let res = await loadMultipleFiles(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				window.open(imgSrc(res.data.data));
			}
		},
		receiptSizeChange(val) {
			this.receipt_page_size = val;
		},
		receiptCurrentChange(val) {
			this.receipt_page_no = val;
		},
		// 查看FBA标签
		async checkFBASKUtally(id) {
			this.checkFilesReceipt(id, 'tally');
			// this.$refs['my-upload'].clearFiles();
			// this.clearFiles()
		},

		//下载FBA标签二维码
		async loadMultipleQRcode(row) {
			console.log(row);
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				SKULST: row.PID + '-' + row.ID + '-' + row.index
			};
			let res = await getQrCode(param);
			loading.close();
			console.log(res.data);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				window.open(imgSrc(res.data));
			}
		},

		// 填写FBA标签备注
		async setTalllyRemark(obj) {
			if (!obj.REMARK) {
				return;
			}
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				ID: obj.ID,
				REMARK: obj.REMARK,
				REMARKTIME: this.now,
				REMARKUSE: this.$store.state.JHSS.personalUserid
			};
			let res = await setTallyFileRemark(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.$message.success(this.$t('message.remarkFillSuccess'));
				this.checkFilesReceipt(obj.PID, 'tally');
			}
		},
		// 确认FBA标签
		async affirmTally() {
			if (this.receiptSelectTable.length === 0) {
				this.$message(this.$t('message.exportDatePlaceholder'));
			} else {
				let list = this.receiptSelectTable.map(item => {
					return item.ID;
				});
				let param = {
					IDLST: list.join(','),
					TAKENAME: this.$store.state.JHSS.personalAccount,
					TAKEUSE: this.$store.state.JHSS.personalUserid,
					TAKETIME: this.now
				};
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading'
				});
				let res = await affirmTallyFile(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
				} else if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.searchTally();
				}
			}
		},
		// 取消确认
		async cancelAddirm(id) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				IDLST: id
			};
			let res = await affirmTallyFile(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.searchTally();
			}
		},
		// FBA标签删除
		async delTallyFiles(id, type) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				IDLST: id,
				DELUSE: this.$store.state.JHSS.personalUserid
			};
			let res = await delTallyFile(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				if (type === 'oneOrder') {
					console.log(this.receiptPid);
					this.checkFBASKUtally(this.receiptPid);
					this.getContainerOrder();
				} else {
					this.searchTally();
					this.getContainerOrder();
				}
			}
		},
		//点击展开SKU
		toggleRowExpansion(row) {
			this.expands = [];
			this.expands.push(row.ID);
			console.log(row);
			this.FBAID = row.ID;
			this.checkSKUtally(row.ID);
			// this.checkSKUtally(row,row.ID);
		},
		//保存FBA主表ID便于查询SKU子表
		savesFBAID(row) {
			console.log(row);
			this.FBAID = row.ID;
		},
		savesSKUID(row) {
			console.log(row);
			this.SKUID = row.ID;
		},

		//查询SKU文件

		//查看SKU
		async checkSKUtally(id) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { PID: id };
			let res = {};
			res = await getSKUTallyFile(param);

			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				let index = 0;
				// row.SKUList
				this.SKUList = res.data.dt.map(item => {
					item.index = ++index;
					// item.SKU = !item.SKU ? '' : item.SKU;
					// item.REMARK = !item.REMARK ? '' : item.REMARK;
					// item.NAME = !item.NAME ? '' : item.NAME;
					// item.NUMBER = item.NUMBER ? '' : item.NUMBER;
					return item;
				});
				// param.ADDUSERID = this.$store.state.JHSS.personalUserid;
			}
		},

		//保存SKU信息
		async savesSKUTallyFiles(obj) {
			if (!obj.SKULST) {
				return;
			}
			console.log(this.FBAID);
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				ID: obj.ID,
				SKULST: obj.SKULST,
				REMARK: obj.REMARK,
				DTNAME: obj.DTNAME,
				DTNUM: obj.DTNUM,
				REMARKUSE: this.$store.state.JHSS.personalUserid
			};
			let res = await setSKUTallyFile(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.$message.success(this.$t('message.SKUInfoFillSuccess'));
				// this.checkFilesReceipt(obj.PID, 'tally');
				this.checkSKUtally(this.FBAID);
			}
		},

		//删除SKU标签
		async delSKUTallyFiles(id) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = {
				ID: id,
				DELUSE: this.$store.state.JHSS.personalUserid
			};
			let res = await delSKUTallyFile(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.checkSKUtally(this.FBAID);
			}
		},
		async tallyRemove() {
			if (this.receiptSelectTable.length === 0) {
				this.$message(this.$t('message.exportDatePlaceholder'));
			} else {
				let list = this.receiptSelectTable.map(item => {
					return item.ID;
				});
				this.delTallyFiles(list.join(','), 'allOrder');
			}
		},
		// 搜索标签
		async searchTally() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = { CITY: this.city, ADDUSERID: this.$store.state.JHSS.personalUserid, FILEOLDNAME: this.tallyName, TAKEUSE: this.tallyTakeUse, state: this.tallyState };
			if (this.tallyUploadDate !== null) {
				param.UADDDATE = this.tallyUploadDate[0] + ' 00:00:00';
				param.DADDDATE = this.tallyUploadDate[1] + ' 23:59:59';
			}
			let res = await getDayTallyFile(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				// console.log(res.data)
				this.receiptSelectTable = [];
				this.receipt_page_no = 1;
				this.receipt_page_size = 10;
				let index = 0;
				this.receiptDialogList = res.data.dt.map(item => {
					item.index = ++index;
					item.href = imgSrc(item.FILENAME);
					item.name = item.FILEOLDNAME;
					item.hasConfirm = !item.TAKENAME ? '' : '√';
					item.affirmTime = !item.TAKETIME ? '' : item.TAKETIME.replace(/T/g, ' ');
					item.ADDTIME = item.ADDTIME.replace(/T/g, ' ');
					return item;
				});
			}
		},
		// 显示选择担当者
		showHeaderDialog(id) {
			//console.log(id)
			this.headerID = id;
			this.headerUserid = '';
			this.headerDialog = true;
		},
		// 确定担当者
		async editHeader() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
			let param = { ID: this.headerID, GUDING1: this.headerUserid, EDITUSER: this.$store.state.JHSS.personalUserid };
			let res = await editHeader(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.headerDialog = false;
				this.getContainerOrder();
			}
		},

		// FBA标签上传成功
		tallySuccess(file) {
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR 2');
			} else {
				this.BinBiaoQianFile(file.data.filename, file.data.fileoldname, 'tally');
				// this.fileUploadSuccess(file.data.filename, file.data.fileoldname, 'tally');
			}
		},
		// 标签上传成功
		tallySuccessFbaAndSku(res,file,fileList) {
	
			if (res.result !== '1') {
				this.$message.error('UPLOAD ERROR');
			} else {
				this.fileUploadSuccess(res.data.filename, res.data.fileoldname, 'tally');
				this.fileArr = fileList
				this.fileArr.forEach((item,index)=>{
						item.progressFlag = false
						if(item.status == 'success'){
								item.successFlag = true
						}else{
								item.successFlag = false
						}
				})
				// this.innerVisible=false
				// item.successFlag=true
				// 	item.progressFlag = false

			}
		},
		// SKU标签上传成功
		SKUSuccess(file) {
			if (file.result !== '1') {
				this.$message.error('UPLOAD ERROR 1');
			} else {
				this.BinBiaoQianFile(file.data.filename, file.data.fileoldname, 'skutally');
			}
		},

		//上传 删除FBA/SKU标签文件
		async BinBiaoQianFile(filename, fileoldname, type, row) {
			console.log('row', row);
			let param = {
				// PID: this.receiptPid,
				FILENAME: filename,
				FILEOLDNAME: fileoldname
			};
			console.log(param);
			let res;
			if (type === 'tally') {
				param.ID = this.FBAID ? this.FBAID : row.ID;
				res = await BinBiaoQianFile(param);
			} else if (type === 'skutally') {
				param.ID = this.SKUID ? this.SKUID : row.ID;
				res = await BinBiaoQianDtFile(param);
			}
			console.log(res);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				this.$message.success('UPLOAD SUCCESS');
				if (type === 'tally') {
					this.checkFBASKUtally(this.receiptPid);
				} else if (type === 'skutally') {
					this.checkSKUtally(this.FBAID);
				}
				this.getContainerOrder();
			}
		},

		//导出文件
		async clickDowlBiaoQian() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.3)'
			});
			let param = {
				PID: this.receiptPid
			};

			let res = await ExportWlBiaoQian(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else {
				console.log('导出文件成功', res);
				let src = await DownloadFile(res.data);
				// loading.close();
				window.open(src);
				// console.log(src)
			}
		},

		BeforeUpload() {
			console.log('BeforeUpload', 'BeforeUpload');
		},
		//点击删除按钮
		clickDelBiaoQian() {
			this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.DelBiaoQianLst();
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		//删除全部FBA列表
		async DelBiaoQianLst() {
			let param = {
				PID: this.receiptPid,
				DELUSE: this.$store.state.JHSS.personalUserid
			};

			let res = await DelBiaoQianLst(param);

			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				this.checkFBASKUtally(this.receiptPid);
				this.getContainerOrder();
			}
		},

		// 导入excel文件
		async uploadExcel() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.3)'
			});
			let param = [];
			param = this.uploadOrder.map(item => {
				let NowRow = {
					PID: this.receiptPid,
					ADDUSER: this.$store.state.JHSS.personalUserid,
					HWDH: item.HWDH,
					AMAZONCODE: item.AMAZONCODE,
					XH: item.XH,
					BQH: item.BQH,
					SKUBQ: item.SKUBQ,
					PCS: item.PCS,
					SPMC: item.SPMC,
					SPBK: item.SPBK,
					SPXZ: item.SPXZ,
					BKL: item.BKL
				};
				return NowRow;
			});
			console.log('数据', param);
			let res = await SetBiaoQianLst(param);
			loading.close();
			console.log('导入数据res：', res);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
			} else if (res.data.result !== '1') {
				// this.$message.error(res.data.message);
				this.$confirm(res.data.message, this.$t('message.promptTitle'), {
					distinguishCancelAndClose: true,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					showCancelButton: false,
					center: true,
					type: 'error'
				});
				this.$message.error(res.data.message);
			} else {
				this.$message.success(this.$t('message.ImpOkText'));
				this.uploadDialog = false;
				this.checkFBASKUtally(this.receiptPid);
				this.getContainerOrder();
				// this.searchFun(this.page_no);
			}
		},
		// 获取上传文件内容
		uploadChange(file) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.3)'
			});
			let _this = this;
			const types = file.name.split('.')[file.name.split('.').length - 1];
			const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);
			if (!fileType) {
				loading.close();
				this.$message(this.$t('message.uploadErrorText'));
				// console.log('aaaaaaaaaaaa');
			} else {
				this.file2Xce(file).then(tabJson => {
					loading.close();
					if (tabJson && tabJson.length > 0) {
						// this.xlsxJson = tabJson
						//console.log('导入数据：', tabJson);
						let index = 0;
						// console.log('tabJson[0].sheet', tabJson[0].sheet);
						_this.uploadOrder = tabJson[0].sheet.map(item => {
							//console.log('导入数据1：', item);
							//console.log('导入数据数组1：', item[1]);
							//console.log('导入数据2：', item['貨物番号\r\n（货物单号）']);

							let obj = {
								index: ++index,
								HWDH: item['貨物番号\r\n（货物单号）'] ? item['貨物番号 \r\n（货物单号）'] : item['貨物番号\r\n（货物单号）'],
								// HWDH: item['貨物番号\r\n（货物单号）'],
								AMAZONCODE: item['Amazon  code'],
								XH: item['箱番号\r\n（箱号）'],
								BQH: item['外装FBAラベル\r\n（FBA标签号）'],
								SKUBQ: item['商品SKUラベル\r\n（SKU标签号）'],
								// PCS: item['数量\r\npcs'],
								PCS: item['数量\r\npcs'],
								SPMC: item['商品名\r\n（商品名称）'],
								SPBK: item['商品備考\r\n（商品备注）'],
								SPXZ: item['商品写真\r\n(商品照片)'],
								BKL: item['備考欄\r\n（贴标备注栏）']
							};

							for (var key in item) {
								if (key.indexOf('貨物番号') >= 0) {
									obj.HWDH = item[key];
								}
								if (key.indexOf('Amazon') >= 0) {
									obj.AMAZONCODE = item[key];
								}
								if (key.indexOf('箱番号') >= 0) {
									obj.XH = item[key];
								}
								if (key.indexOf('FBA') >= 0) {
									obj.BQH = item[key];
								}
								if (key.indexOf('SKU') >= 0) {
									obj.SKUBQ = item[key];
								}
								if (key.indexOf('数量') >= 0) {
									obj.PCS = item[key];
								}
								if (key.indexOf('商品名') >= 0) {
									obj.SPMC = item[key];
								}
								if (key.indexOf('商品備考') >= 0) {
									obj.SPBK = item[key];
								}
								if (key.indexOf('商品写真') >= 0) {
									obj.SPXZ = item[key];
								}
								if (key.indexOf('備考欄') >= 0) {
									obj.BKL = item[key];
								}
							}

							// console.log('obj', obj);
							return obj;
						});
					}
				});
			}
		},

		// 解析excel
		file2Xce(file) {
			return new Promise(function(resolve, reject) {
				const reader = new FileReader();
				reader.onload = function(e) {
					const data = e.target.result;
					this.wb = XLSX.read(data, {
						type: 'binary'
					});

					console.log(this.wb.Sheets);
					// this.wb.Sheets[].forEach(sheet=>{
					// })
					const result = [];
					let sheets = [];
					this.wb.SheetNames.forEach(sheetName => {
						result.push({
							sheetName: sheetName,
							sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
						});
					});

					resolve(result);
				};

				reader.readAsBinaryString(file.raw);
				// reader.readAsBinaryString(file) // 传统input方法
			});
		},		
      // 上传文件
      uploadTemplate () {
        // this.customerSel = ''
        this.importOrder = []
        this.showUpload = true
      },
	  // 导入4kws1
	  async imp_4kws1() {
		this.importOrder = []
		this.showUpload = true		
	  },
      // 导入excle
      uploadChange4k (file) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let _this = this
        let nameList = file.name.split('.')
        const types = nameList[nameList.length - 1]
        const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
        if (!fileType) {
          loading.close()
          this.$message(this.$t('message.uploadOrderFileError'))
        } else {
          this.file2Xce(file).then(tabJson => {
            loading.close()
            if (tabJson && tabJson.length > 0) {
              // this.xlsxJson = tabJson
              // console.log('导入数据：', tabJson[0].sheet)
			  let dz='';
			  let sz='';
			  if(this.city=="藤井寺"){dz="JHSS藤井寺・保税・4KWS1";sz='4KWS1';}
			  if(this.city=="市川"){dz="JHSS市川・保税・2SWH7";sz='2SWH7';}
              this.importOrder = tabJson[0].sheet.map(item => {
                let obj = {
					main: {
						CITY: this.city,
						JOBNO: this.JOBNO,
						JZXSIZE: sz,
						THDIZHI: dz,
						GUDING5:'未許可',
					  JOBNO: this.JOBNO4K,
					  ADDUSER: this.$store.state.JHSS.personalUserid,
					  CUSTOMERID: this.customerSel4K,
					  DADATE: this.deliveryDate4K,
					  THDATE: this.deliveryDate4K,
					  KRZYBH :  item['客户专用编号']?item['客户专用编号']:item['お客様専用番号'],
					  SHULIANG :  item['数量']+" CTNS",
					  ZHONGLIANG :  item['重量']+" KGS",
					  TIJI :  item['体积']?item['体积']+" m³":item['M3']+" m³",
					  REMARK :  item['备注']?item['备注']:item['備考'],
					  GUDING1 : this.$store.state.JHSS.personalAccount
				  },
					lst: []
                }
                // obj.KRZYBH = item['客户专用编号']?item['客户专用编号']:item['お客様専用番号']
                // obj.SHULIANG = item['数量']            
                // obj.ZHONGLIANG = item['重量']
                // obj.TIJI = item['体积']?item['体积']:item['M3']
                // obj.REMARK = item['备注']?item['备注']:item['備考']
                return obj
              })
			  console.log("importOrder",this.importOrder);
            } else {
              this.$message(this.$t('message.uploadOrderNoFileError'))
            }
          })
        }
      },
      // 上传成功
      handleSuccess4k (file) {
        console.log('success', file)
        this.importFile = file.data.filename
        this.importFileOldName = file.data.fileoldname
      },
      handleRemove4k (file) {
        // console.log(file)
        this.importOrder = []
        this.importFile = ''
        this.importFileOldName = ''
      },
      // 确定上传4k文件
      async uploadOrderFile () {
        // console.log(this.importOrder)
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = this.importOrder.map(item => {          
			console.log('item：', item)
          //setContainerOrder(item)
          return item
        })
		param.forEach(item=>{
			console.log('itemitem：', JSON.stringify(item))
			setContainerOrder(JSON.stringify(item))
		})
        loading.close()
		this.getContainerOrder();
        // if (res.status !== 200) {
        //   this.$message.error('network error：' + res.status)
        // } else if (res.data.result !== '1') {
        //   this.$message.error(res.data.message)
        // } else 
		{
          this.showUpload = false          
          this.importOrder = []
          setTimeout(() => {
            this.$refs.amazonOrderList.getAmazonOrder()
          }, 100)
        }
      },
      // 下载模板
      downloadTemplate () {
        let str = HTTPS + '/xlsx/xk.zip';
        window.open(str);
      }
	  
	  
	  
	},
	computed: {
		templateDownload() {
			return imgSrc('FBASKU.xlsx');
		},

		BianQianQrPage() {
			return BianQianQrPage(this.receiptPid);
		},
		uploadFile() {
			return uploadImg;
		},
		  uploadUrl () {
			return uploadImg()
		  },
		// 关东、关西签收单-----分页展示
		receiptShowList() {
			return this.receiptDialogList.slice((this.receipt_page_no - 1) * this.receipt_page_size, this.receipt_page_no * this.receipt_page_size);
		},
		now() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1 > 9 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1);
			let date = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
			let hour = now.getHours() > 9 ? now.getHours() : '0' + now.getHours();
			let minute = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes();
			let seconds = now.getSeconds() > 9 ? now.getSeconds() : '0' + now.getSeconds();
			return year + '/' + month + '/' + date + 'T' + hour + ':' + minute + ':' + seconds;
		}
	},
	filters: {
		formDate(value) {
			if (value) {
				let str= value.split("T")
				
				let index = str[0].indexOf("-");
				let str1=str[0].substring(index+1,str[0].length)
				
				 index = str[1].lastIndexOf(":")
				let str2 =str[1].substring(0,index);
				
				return  str1+" "+str2
			}
		}
	}
};
</script>

<style scoped>
.file{
	display: flex;
	flex-direction: column;
}
.file_item{
	display: flex;
}
.file_item .name{
	width: 260px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align: left;
}
.file_item .progress{
	width: 240px;
}
.el-input {
	/* width: initial; */
	/* flex-grow: 1; */
}
/deep/ .el-textarea {
	width: 45%;
}
/deep/ .el-textarea__inner {
	text-align: left;
}
.color1 {
	color: #0048ff;
}
.color2 {
	color: #00cbc9;
}
.color3 {
	color: #ff8524;
}
.color4 {
	color: #00b7ff;
}
.color5 {
	color: #00b7ff;
	font-weight: bold;
}
.color6 {
	color: #9800ff;
}
.color7 {
	color: #fa02f1;
}
.color8 {
	color: #fa02f1;
}
.color9 {
	color: #fa4865;
}
.sendEmailBtn {
	width: 25px;
	background: url(../../assets/sendEmailIcon.svg) no-repeat center;
}
/deep/ .demo-table-expand {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}
/deep/ .el-form-item {
	margin-bottom: 0;
}
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  background-color:#000000;
}
.RedText{
	font-weight: 800;
	color: red;
	font-size: 13px;
}
.GreenText{
	font-weight: 800;
	color: green;	
	font-size: 13px;
}
</style>
